// https://app.growthbook.io/features/pen-7401_v1
export const PEN_7401_FLAG = 'pen-7401_v1'
